import { useTransportQuery } from "@/transport"

export const useMetricStringValuesTransport = (
  metricId: string | undefined,
  options?: { enabled?: boolean; isUploadedConversation?: boolean },
) => {
  return useTransportQuery({
    operation: "getUploadedConversationMetricStringValues",
    request: {
      metric_id: metricId ?? "",
      is_monitoring: options?.isUploadedConversation,
    },
    options: {
      enabled: (options?.enabled ?? true) && !!metricId,
      staleTime: 5 * 60 * 1000,
      select: (response) => response.values ?? [],
    },
  })
}
